import React from 'react';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import {
  trackAnalytics, makeExternalUrl, attachLocale, toSlug
} from '../../../../lib/utils';
import { DOM_GREETING_SECTION } from '../../../../lib/constants';
import {
  GenericGreetingContainerDiv,
  GreetingSectionHeaderDiv,
  GreetingSectionSubHeaderDiv,
  GreetingCenteredSectionWithTopMargin,
  GreetingSectionImage,
} from './GreetingSectionSharedStyles';
import CenteredRowDiv from '../shared/CenteredRowDiv';
import Button from '../Button/Button';

const GreetingSectionZeroFavs = (props) => {
  const {
    locale,
    userLoggedInZeroFavouriteShopsLineOne,
    userLoggedInZeroFavouriteShopsLineTwo,
    userLoggedInZeroFavouriteShopsImage,
    userLoggedInZeroFavouriteShopsImageAltText,
    userLoggedInZeroFavouriteShopsCtaText,
    userLoggedInZeroFavouriteShopsCtaUrl,
    userLoggedInZeroFavouriteShopsCtaTagSet,
  } = props;

  const resolvedUserLoggedInZeroFavouriteShopsImage = makeExternalUrl(userLoggedInZeroFavouriteShopsImage);

  const resolvedCtaUrl = attachLocale(userLoggedInZeroFavouriteShopsCtaUrl, locale);

  const ctaTrack = trackAnalytics(
    `${DOM_GREETING_SECTION}-zero-favs`,
    `${toSlug(userLoggedInZeroFavouriteShopsCtaText)}`,
    resolvedCtaUrl,
    userLoggedInZeroFavouriteShopsCtaTagSet
  );

  const renderPage = (mobile) => {
    return (
      <GenericGreetingContainerDiv>
        <CenteredRowDiv>
          <GreetingSectionImage
            src={resolvedUserLoggedInZeroFavouriteShopsImage}
            alt={userLoggedInZeroFavouriteShopsImageAltText}
          />
        </CenteredRowDiv>

        <GreetingCenteredSectionWithTopMargin>
          <GreetingSectionHeaderDiv isMobile={mobile}>
            { userLoggedInZeroFavouriteShopsLineOne }
          </GreetingSectionHeaderDiv>
        </GreetingCenteredSectionWithTopMargin>

        <GreetingSectionSubHeaderDiv isMobile={mobile}>
          { userLoggedInZeroFavouriteShopsLineTwo }
        </GreetingSectionSubHeaderDiv>

        <GreetingCenteredSectionWithTopMargin top={32}>
          <Button
            variant="primary"
            size="medium"
            buttonText={userLoggedInZeroFavouriteShopsCtaText}
            {...ctaTrack}
          />
        </GreetingCenteredSectionWithTopMargin>
      </GenericGreetingContainerDiv>
    );
  };

  return (
    <MediaQueryHelper
      desktopChildren={renderPage()}
      mobileChildren={renderPage(true)}
    />
  );
};

export default GreetingSectionZeroFavs;
